








































































































import {Component, Vue, Watch, Prop} from 'vue-property-decorator';
import {Table, CardForm} from '@/components/bwaff';
import DomainsApi from '@/services/rest/bemob/domains';
import { mixins } from 'vue-class-component';
import GetUsingTypeMixin from '@/i18n/getUsingType-mixin';
import moment from 'moment';

@Component({
  components: {
    CardForm,
    DataTable: Table,
  }
})

export default class Cloaking extends mixins(GetUsingTypeMixin) {
  domainsApi: DomainsApi = new DomainsApi();
  loading: boolean = false;

  async mounted() {
    if(!this.$store.state.cache.redirectDomains.isUploaded){
      await this.domainsApi.redirectDomainsPopulateStoreCache()
    }
  }

  rows: any[] = [];
  form: any = {};
  rowsOnPage: number = 10;
  pagination: any = {
    rowsPerPage: this.rowsOnPage
  };
 
  checkDelete(id: string) {
    this.bus.emit('open-dialog', { name: 'ConfirmDialog', data: {
      message: this.t('All selected items will be deleted permanently if you press OK.'),
        onConfirm: () => {
        this.domainsApi.deleteRedirectDomain(id)
          .then(()=>{
            this.bus.emit('toast-success', this.t('Domain deleted'));
          }).catch((e: any)=>{
          for(let item of e.response?.data?.errors?.id[0]) {
            let usingType = this.getUsingType({type:item.usingType});
            let message = this.t('{0} is used by {1} {2}', [item.usedName,usingType,item.usingName]);

            this.bus.emit('toast-warning', message,{
              dontHide:true
            });
          }
        });
      },
    }})
  }

  setAsDefault(id: string) {
    this.$store.commit('loading', true);
    return this.domainsApi.updateUserDomainData({redirectDomainId: id}).then((res: any) => {
      this.$store.commit('updateUser', res);
    }).finally(()=>
      this.$store.commit('loading', false));
  }

  get headers() {
    return [
      {
        text: this.t('Domain'),
        align: 'left',
        value: 'domain',
        sortable: false
      },
      {
        text: '',
        value: 'setMain',
        align: 'right',
        sortable: false
      },
      {
        text: '',
        value: 'action',
        align: 'right',
        sortable: false
      }
    ];
  }

  addCustomDomain() {
    this.bus.emit('open-dialog', {
      name: 'AddCustomCloakingDomainDialog',
    });
  }

  isNextDnsRecordValidationAfterYear(item) {
    return moment().add(1, 'year').isBefore(item.nextDnsRecordValidation)
  }
}
